import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Icon, SimpleSelectField } from '@unite-us/app-components';

const PRIMARY_WORKER_TOOLTIP = 'This list shows up to 50 results at a time. Type user name to refine your search.';

const normalizePrimaryWorkerValue = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && value.id != null) {
    return String(value.id);
  }
  return String(value);
};

const primaryWorkerLabel = (
  <div className="flex items-center gap-1">
    <span>Primary Worker</span>
    <span
      className="primary-worker-select__info-icon normal-case"
      data-tooltip={PRIMARY_WORKER_TOOLTIP}
      data-tooltip-bottom-right
      role="presentation"
    >
      <Icon icon="InfoCircle" size={14} className="fill-current text-text-blue" />
    </span>
  </div>
);

const PrimaryWorkerSelectField = ({
  options,
  onInputChange,
}) => (
  <Field name="primary_worker_id">
    {({ input, meta }) => (
      <SimpleSelectField
        className="primary-worker-select"
        id="primary-worker"
        label={primaryWorkerLabel}
        options={options}
        value={normalizePrimaryWorkerValue(input.value)}
        onChange={(selectedValue) => input.onChange(selectedValue || null)}
        onBlur={input.onBlur}
        placeholder="Search - Displaying 50 max"
        clearable={false}
        searchable
        error={meta.touched && meta.error ? meta.error : undefined}
        onInputChange={onInputChange}
      />
    )}
  </Field>
);

PrimaryWorkerSelectField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      id: PropTypes.string,
    }),
  ).isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default PrimaryWorkerSelectField;
export { PRIMARY_WORKER_TOOLTIP, primaryWorkerLabel };
